<template>
	<layout-main>
		<template #toolbar>
			<layout-tool-bar />
		</template>

		<v-container class="fill-wh">
			<v-card id="lock-manager" class="fill-wh" :loading="isLoading">
				<layout-master-detail :show-details="showDetails" :aside-size="35">
					<div class="d-flex justify-center fill-height">
						<List
							v-if="locks.length"
							class="flex-grow-1"
							item-text="roomName"
							:items="locks"
							:options="lockOptions"
							@click="openDetails('manage', $event)"
						/>
						<div v-else-if="!isLoading" class="mx-auto pt-4">
							No registered locks found for this community.
						</div>
					</div>

					<template #detail>
						<Sidebar
							:is="currentSidebar"
							:lock="selectedItem"
							@close="closeDetails"
						>
							{{ selectedItem }}
						</Sidebar>
					</template>
				</layout-master-detail>
			</v-card>
		</v-container>

		<LockFAB
			v-if="isAdmin"
			:class="{ 'd-none': showDetails }"
			class="d-md-block"
			@select="openDetails"
		/>
	</layout-main>
</template>

<script>
import _ from "lodash";
import List from "./list/Index.vue";
import LockFAB from "./LockSpeedDial.vue";
import Manage from "./sidebar/Lock.vue";
import Users from "./sidebar/Users.vue";
import Register from "./sidebar/Register.vue";
import { mapActions, mapGetters } from "vuex";
import ability from "@/services/ability";

export default {
	components: {
		List,
		LockFAB,
		Manage,
		Users,
		Register,
	},

	data() {
		return {
			currentSidebar: null,
			selectedItem: null,
			loading: {
				login: false,
				locks: false,
			},
			// locks: [
			// 	{ id: 1, title: "Room 101" },
			// 	{ id: 2, title: "Room 202" },
			// ],
		};
	},

	computed: {
		...mapGetters({
			locks: "locks/rooms",
		}),
		lockOptions() {
			return [
				{
					title: "Unregister",
					type: "remove",
					action: this.unregisterLock,
				},
			];
		},

		showDetails() {
			return !!this.currentSidebar;
		},

		isLoading() {
			return _.some(this.loading);
		},

		isAdmin() {
			return ability.can("manage", "LockManager");
		},
		isAllowed() {
			return ability.can("read", "LockManager");
		},
	},

	async created() {

		await this.login();
		await this.getLocks();
		
	},

	methods: {
		...mapActions({
			_login: "locks/login",
			_getLocks: "locks/getRooms",
			unpairLock: "locks/unpairLock",
		}),

		async login() {
			this.loading.login = true;
			try {
				await this._login();
			} finally {
				this.loading.login = false;
			}
		},

		async getLocks() {
			this.loading.locks = true;
			try {
				await this._getLocks();
			} finally {
				this.loading.locks = false;
			}
		},

		async unregisterLock(lock) {
			await this.unpairLock(_.get(lock, "deviceId"));
			this.getLocks();
		},

		openDetails(type, item) {
			this.currentSidebar = type;
			this.selectedItem = item;
		},

		closeDetails() {
			this.currentSidebar = null;
			this.selectedItem = null;
		},
	},
};
</script>
